module.exports = __webpack_public_path__ + "media/images/awards/award-photo-1-7dd5bc70ec74f2c490bea7f7ce42bf3e.jpeg";